import CustomizedDialogs from '../../../common/CustomizedDialogs'
import { Box, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import '../../../style/modal/DynamicQR.scss'
import InfoCircleIcon from '../../../assets/Icons/InfoCircleIcon';
import QRTimer from '../../../common/QRTimer';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useRef } from 'react';
import axios from 'axios';
import { QRBaseUrl } from '../../../assets/extra/_httpServices';
import { showErrorAlert } from '../../../redux/Actions';
import { bookingQrBkgDetailsInsertUpdate } from '../../../redux/Booking/BookingActions';
const DynamicQR = (props) => {
    const { open = false, titleText = '', bkgDetails = {}, onClose = () => { }, data = {}, handlePaymentSuccess = () => { } } = props

    const dispatch = useDispatch()
    const store = useSelector((store) => store);
    const { user } = store;
    const { userDetails } = user;
    const timerRef = useRef(null);
    const abortControllerRef = useRef(null);

    const fetchQRCode = async () => {
        try {
            abortControllerRef.current = new AbortController();
            const res = await axios.get(`${QRBaseUrl}/v1/orders/${data?.orderId}/status`, {
                signal: abortControllerRef.current.signal,
            })
            if (res?.data?.isSuccess) {
                if (res?.data?.data?.status === "PAYMENT_PENDING" || res?.data?.data?.status === 'PAYMENT_INITIATED') {
                    handleStatusUpdated(res?.data?.data)
                    timerRef.current = setTimeout(fetchQRCode, 3000);
                } else if (res?.data?.data?.status === "PAYMENT_FAILURE") {
                    dispatch(showErrorAlert('Payment Failed'))
                    handleStatusUpdated(res?.data?.data)
                } else if (res?.data?.data?.status === "PAYMENT_SUCCESS") {
                    handleStatusUpdated(res?.data?.data)
                }
            } else {
                dispatch(showErrorAlert(res?.data?.error))
            }
        } catch (error) {
            if (error.name === 'CanceledError') {
                console.log("API request canceled");
            } else {
                console.error("Error fetching QR:", error);
            }
        }
    };
    useEffect(() => {
        if (!open) return;
        fetchQRCode();
        return () => {
            clearTimeout(timerRef.current);
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, [open, data?.orderId]);

    const handleStopPayment = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }

        // Abort any ongoing API call
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();  // This cancels axios call
            abortControllerRef.current = null;
        }

        // Close modal
        onClose();
    };

    const handleStatusUpdated = (statusData = {}) => {
        const body = {
            intorderid: statusData?.orderId,
            decamount: statusData?.amount || 0,
            decpgcharge: statusData?.pgCharge || 0,
            decpgamount: statusData?.pgAmount || 0,
            strstatus: statusData?.status || '',
            strmerchanttxnid: statusData?.merchantTxnId || '',
            strpgtxnid: statusData?.pgTxnId || '',
            dtstatustime: statusData?.statusTime || '',
            intcompanyid: bkgDetails?.tripCompanyID || 0,
            intentityid: userDetails.AgentID,
            strentitytype: 'A',
            BusinessVerticleId: 1,
            paymentproducttypeid: 9,
            entityPaymentid: 0,
            userid: userDetails.AgentUserID,
            qrUTRNumber: statusData?.qrUTRNumber || '',
            RechargeStatus: 'QR Generated',
            transferfee: statusData?.transferFee || 0,
            strpgname: '',
            mobileno: bkgDetails?.phoneNumber,
            intbranchid: 0,
            refStatus: '',
            refStatusTime: '01-01-0001 00:00:00',
            refUserID: 0,
        }
        dispatch(bookingQrBkgDetailsInsertUpdate(body)).then((res) => {
            if (res?.data?.status) {
                if (statusData?.status === 'PAYMENT_SUCCESS') {
                    handleStopPayment()
                    handlePaymentSuccess(statusData?.orderId, statusData?.pgTxnId)
                } else if (statusData?.status === 'PAYMENT_PENDING' || statusData?.status === 'PAYMENT_INITIATED') {

                } else {
                    handleStatusUpdated('Payment Failed')
                    handleStopPayment()
                }
                return
            } else {
                handleStatusUpdated(res?.data?.Message)
                handleStopPayment()
            }
        })
    }
    return (
        <CustomizedDialogs
            open={open}
            width={'420px'}
            height={'auto'}
            onClose={() => { }}
            padding={'0px'}
        >
            <Box className='dynamicQR-container'>
                <Box className='qr-header-section'>
                    <CloseIcon sx={{ color: '#666666', width: '16px ', height: '16px' }} onClick={handleStopPayment} />
                </Box>
                <Box className='header-text-section'>
                    <Typography sx={{ color: '#202020' }}>Scan to Pay</Typography>
                    <Typography sx={{ color: '#0086FF' }}>Payment amount: {data?.amount}</Typography>
                </Box>
                <Box className='time-section'>
                    <InfoCircleIcon />
                    <QRTimer onExpire={() => {
                        dispatch(showErrorAlert('15 Minutes completed still payment not received.'))
                        handleStopPayment()
                    }} />
                </Box>
                <Box>
                    <div
                        id="qrCode"
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundImage: `url(${data?.qrUrl})`,
                            padding: '8px',
                            height: '187.39px',
                            width: '185px',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                        }}
                    />
                </Box>
                <Box className='bottom-Section-text'>
                    <Typography>Scan &  Pay any UPI Apps</Typography>
                </Box>
                <Box className='image-section'>
                    <img src="./images/AppImage.png" alt="AppImage" srcset="" style={{
                        height: '20px'
                    }} />
                </Box>
            </Box>

        </CustomizedDialogs>
    )
}

export default DynamicQR